<template>
  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0">Blacklist Müşteri Listesi</h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <router-link tag="li" to="/" class="breadcrumb-item"><a>Anasayfa</a></router-link>
              <li class="breadcrumb-item active">Blacklist Listesi</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </div>
    <!-- /.content-header -->

    <!-- Main content -->
    <div class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header card-title">
                Blacklist Müşteri Listesi
                <button class="btn btn-primary btn-sm float-right" @click="resetModal"
                  v-if="auth.Blacklist != null && auth.Blacklist.isWrite">
                  <i class="fas fa-plus"> </i> Yeni Blacklist
                </button>
              </div>
              <div class="card-body">
                <div class="overlay-wrapper">
                  <div class="overlay" v-if="overlay">
                    <i class="fas fa-3x fa-spinner fa-spin"></i>
                  </div>
                  <div class="row">
                    <div class="col-xl-2 my-1">
                      <input type="text" placeholder="Müşteri ID" class="form-control form-control-sm"
                        v-model="search.code" />
                    </div>

                    <div class="col-xl-2 my-1">
                      <select class="form-control form-control-sm" v-model="search.bonus">
                        <option value="">Tür Seçiniz</option>
                        <option value="yatirim-bonus">
                          Yatırım (Hoş Geldin) Bonusları
                        </option>
                        <option value="freebet">
                          Freebet ve Freespin Bonusları
                        </option>
                        <option value="kayip-spor">Spor Kayıp Bonusları</option>
                        <option value="kayip-casino">
                          Casino Kayıp Bonusları
                        </option>
                        <option value="tumu">Tüm Bonuslar</option>
                      </select>
                    </div>

                    <div class="col-xl-2 my-1">
                      <button class="btn btn-info btn-sm w-100" @click="pagination">
                        <i class="fas fa-search"></i> Filtrele
                      </button>
                    </div>
                    <div class="col-xl-2 my-1">
                      <button class="btn btn-danger btn-sm w-100" @click="reset">
                        Temizle
                      </button>
                    </div>
                    <div class="col-xl-2 my-1"></div>
                    <div class="col-xl-2 my-1">
                      <button class="btn btn-outline-success btn-sm w-100" @click="exportToExcel">
                        <i class="fas fa-file"></i> Export to Excel
                      </button>
                    </div>
                  </div>
                  <br />
                  <div class="table-responsive">
                    <table class="table table-striped projects">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Müşteri ID</th>
                          <th>İşlem Zamanı</th>
                          <th>Bonus Türü</th>
                          <th style="width: 250px">Açıklama</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(data, index) in datas" :key="index">
                          <td>{{ ++index + (page - 1) * count }}</td>
                          <td>
                            {{ data.customerCode }}
                          </td>
                          <td>
                            {{ data.addDate | DateFormat }}
                          </td>
                          <td>{{ data.type }}</td>
                          <td>
                            {{ data.aciklama }}
                          </td>
                          <td>
                            <button class="btn btn-outline-danger btn-sm" @click="del(data.ID)">
                              <i class="fa fa-trash"></i>
                            </button>
                          </td>
                        </tr>
                        <tr>
                          <td v-if="datas.length == 0" colspan="6" class="text-center">
                            Kayıt Bulunamadı
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <pagination v-model="page" :records="rows" :per-page="count" @paginate="pagination" />
              </div>
            </div>

            <!-- /.card -->
          </div>
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </div>
    <div class="modal fade" id="modal">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">
              Blacklist {{ data.id ? "Düzenleme" : "Ekleme" }}
            </h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="onSubmit">
              <div class="form-group">
                <label>Müşteri IDs</label>
                <textarea @blur="$v.data.code.$touch()" v-model="$v.data.code.$model" class="form-control"
                  :class="{ 'is-invalid': $v.data.code.$error }"
                  placeholder="Customer Kodları Arasını virgül(,) ile ayırınız"></textarea>
                <small v-if="!$v.data.code.required && $v.data.code.$error" class="form-text text-danger">Bu alan
                  zorunludur...</small>
              </div>
              <div class="form-group">
                <label>Bonus Tipi</label>
                <select v-model="data.type" type="text" class="form-control" multiple>
                  <option value="yatirim-bonus">
                    Yatırım (Hoş Geldin) Bonusları
                  </option>
                  <option value="freebet">Freebet ve Freespin Bonusları</option>
                  <option value="kayip-bonus">Spor Kayıp Bonusları</option>
                  <option value="casino-kayip-bonus">Casino Kayıp Bonusları</option>
                  <option value="tumu">Tüm Bonuslar</option>
                </select>
              </div>
              <div class="form-group">
                <label>Açıklama</label>
                <textarea v-model="data.description" class="form-control" placeholder="Açıklama giriniz"></textarea>
              </div>
            </form>
          </div>

          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              İptal
            </button>
            <button type="button" class="btn btn-primary" @click="save()" :disabled="$v.data.$invalid">
              Kaydet
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.content -->
  </div>
  <!-- /.content-wrapper -->
</template>
<script>
import { required } from "vuelidate/lib/validators";
export default {
  data() {
    return {
      page: 1,
      count: 10,
      rows: 0,
      datas: [],
      auth: this.$store.getters.getModules,
      data: {
        id: 0,
        code: [],
        type: [],
        description: "",
      },
      overlay: false,
      search: {
        code: "",
        bonus: "",
      },
    };
  },
  validations: {
    data: {
      code: { required },
    },
  },
  methods: {
    pagination(value) {
      this.getDatas();
      this.getDatas(true);
    },
    reset() {
      this.page = 1;
      this.search = {
        code: "",
        bonus: "",
      };
      this.getDatas();
      this.getDatas(true);
    },
    getDatas(type = false) {
      if (!type) this.overlay = true;
      this.$http
        .post("Blacklist/ListBlacklist", {
          code: this.search.code.trim(),
          bonus: this.search.bonus,
          rowNumber: type,
          page: this.page - 1,
        })
        .then((response) => {
          if (type) this.rows = response.data;
          else {
            this.datas = response.data;
            this.overlay = false;
          }
        });
    },
    exportToExcel() {
      this.overlay = true;
      this.$http
        .post("Blacklist/ExportBlackListToExcel", {
          code: this.search.code.trim(),
          bonus: this.search.bonus,
        })
        .then((response) => {
          this.overlay = false;
          var bytes = this.base64ToArrayBuffer(response.data);
          let reportName = `_blacklist_customers_${new Date().toLocaleDateString()}.xlsx`;
          this.saveByteArray(reportName, bytes);
        });
    },
    save() {
      let data = [];
      let codeArray = this.data.code;
      let codeEntity = codeArray.replaceAll(' ', '').split(',').filter(x => x);
      let description = this.data.description;

      for (var i = 0; i < codeEntity.length; i++) {
        $.each(this.data.type, function (x, item) {
          data.push({
            code: codeEntity[i],
            type: item,
            description: description,
          });
        });
      }

      this.$http.post("Blacklist/AddBlacklist", data).then((response) => {
        $("#modal").modal("hide");
        toastr.success("Kayıt başarılı.");
        this.getDatas();
        this.getDatas(true);
      });
    },
    resetModal() {
      this.data = {
        id: 0,
        code: [],
        type: [],
        description: "",
      };
      this.$v.$reset();
      $("#modal").modal();
    },
    del(id) {
      Swal.fire({
        title: "Kayıt kalıcı olarak silinecek! Onaylıyor musunuz?",
        showCancelButton: true,
        confirmButtonText: "Evet! Silinsin",
        cancelButtonText: "İptal",
        icon: "question",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          this.$http.get("Blacklist/DeleteBlacklist/" + id).then((response) => {
            toastr.success("Kayıt başarıyla silindi.");
            this.getDatas();
          });
        }
      });
    },
    base64ToArrayBuffer(base64) {
      var binary_string = window.atob(base64);
      var len = binary_string.length;
      var bytes = new Uint8Array(len);
      for (var i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
      }
      return bytes.buffer;
    },
    saveByteArray(reportName, byte) {
      var blob = new Blob([byte], { type: "application/octetstream" });
      var isIE = false || !!document.documentMode;
      if (isIE) {
        window.navigator.msSaveBlob(blob, reportName);
      } else {
        var url = window.URL || window.webkitURL;
        var link = url.createObjectURL(blob);
        var a = $("<a />");
        a.attr("download", reportName);
        a.attr("href", link);
        $("body").append(a);
        a[0].click();
        $("body").remove(a);
      }
    }
  },
  filters: {
    DateFormat(value) {
      if (!value) return "İşlem Sırasında";

      let date = value.split("T")[0].split("-");
      let time = value.split("T")[1].split(".")[0];
      return date[2] + "/" + date[1] + "/" + date[0] + " " + time;
    },
  },
  created() {
    this.getDatas();
    this.getDatas(true);
  },
  watch: {
    "$store.getters.getSite"() {
      this.getDatas();
      this.getDatas(true);
    },
    "$store.getters.getModules"() {
      this.auth = this.$store.getters.getModules;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Blacklist/blacklist.vue